module.exports = __webpack_public_path__ + "static/media/hotelGoiania02.d1826855.jpg";